module.exports = __webpack_public_path__ + "static/media/incentives-screenshot.765e6358.png";